/**
 * cloudTrail模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const cloudTrail = {
  	// 显示列表
  	listCloudTrailEvent(params) {
    	return $http.post(`${global.API_URL}/sme/cloudTrail/listCloudTrailEvent`,params);
  	},
  	//导出
  	exportCloudTrailSecurityEvents(params) {
    	return $http.post(`${global.API_URL}/sme/cloudTrail/exportCloudTrailSecurityEvents`, params, {
        	responseType: 'arraybuffer',
        	timeout: 1000 * 60 * 5
    	});
  	},
    //查询CloudTrail安全事件
    queryCloudTrailSecurityEvents(id ,params) {
      let param = new URLSearchParams();
      param.append(id, params);
      return $http.post(`${global.API_URL}/sme/cloudTrail/queryCloudTrailSecurityEvents`,param);
    },
}

export default cloudTrail;



// WEBPACK FOOTER //
// ./src/api/cloudTrail.js